import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import SocialRecreationalSeniorsDetails from '../../subdepartmentdetails/SocialRecreationalSeniors'


function SocialRecreationalSeniors() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Social and Recreational Activities for Seniors || Senior Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Senior Services"
            title="Social Recreational Seniors"
            subtitledown="Department of Senior Services"
           />
            <SocialRecreationalSeniorsDetails/>
        </div>
    </>
  )
}

export default SocialRecreationalSeniors